import { FeatureFlag, FeatureFlags } from './types';

declare const FEATURES_FLAGS: FeatureFlags;

class FeatureFlagManager {
	private _flagListeners = new Set<() => void>();

	private _organizationOverrides: Partial<FeatureFlags> = {};

	private readonly _staticFlags: Partial<FeatureFlags>;

	constructor() {
		this._staticFlags = FEATURES_FLAGS;
	}

	broadcastFlagsUpdated = () => {
		this._flagListeners.forEach(onFeatureFlagsChanged => onFeatureFlagsChanged());
	};

	listen = (onFeatureFlagsChanged: () => void) => {
		this._flagListeners.add(onFeatureFlagsChanged);
		return () => {
			this._flagListeners.delete(onFeatureFlagsChanged);
		};
	};

	computedFeatureValue = (featureName: FeatureFlag) => {
		const organizationOverrideFeature = this._organizationOverrides[featureName];
		if (organizationOverrideFeature !== undefined) {
			return organizationOverrideFeature;
		}
		const baseFlagsFeature = this._staticFlags[featureName];
		return Boolean(baseFlagsFeature);
	};

	get allFlags() {
		return Object.freeze(
			Object.keys(this._staticFlags)
				.map(key => ({
					name: key as keyof FeatureFlags,
					value: this.computedFeatureValue(key as keyof FeatureFlags),
				}))
				.sort((a, b) => a.name.localeCompare(b.name))
		);
	}
}

export const featureFlagManager = new FeatureFlagManager();
